import { useI18n } from '@/context/I18nContext';
import { CrudPage, type CrudColumn, type CrudField } from '@/components/crud/CrudPage';

interface Axle {
  id: string;
  brand: string;
  type: string;
  stiffness: string;
  teamId: string;
}

export function AxlesTab({ teamId, readOnly }: { teamId: string; readOnly?: boolean }) {
  const { t } = useI18n();

  const columns: CrudColumn<Axle>[] = [
    { key: 'brand', label: t('common.brand') },
    {
      key: 'type',
      label: t('common.type'),
      render: (a) => (
        <span className="inline-block px-2.5 py-0.5 bg-accent-subtle border border-accent/20 rounded-full text-xs font-medium text-accent-hover tracking-wide">
          {a.type}
        </span>
      ),
    },
    {
      key: 'stiffness',
      label: t('common.stiffness'),
      className: 'w-[80px] text-text-secondary tabular-nums text-sm',
    },
  ];

  const fields: CrudField[] = [
    { key: 'brand', label: t('common.brand'), placeholder: 'e.g. Kosmic' },
    { key: 'type', label: t('common.type'), placeholder: 'e.g. Medium' },
    { key: 'stiffness', label: t('common.stiffness'), placeholder: 'e.g. 2.5', inputMode: 'decimal' },
  ];

  return (
    <CrudPage<Axle>
      title={t('materials.tab.axles')}
      entityName={t('materials.entity.axle')}
      emptyIcon="⚙️"
      columns={columns}
      fields={fields}
      listMethod="ListAxles"
      createMethod="CreateAxle"
      updateMethod="UpdateAxle"
      deleteMethod="DeleteAxle"
      listParams={{ teamId }}
      readOnly={readOnly}
      hiddenValues={{ teamId }}
    />
  );
}
